import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 9l6 6","key":"svg-0"}],["path",{"d":"M2 15l6 -6","key":"svg-1"}],["path",{"d":"M16 9l6 6","key":"svg-2"}],["path",{"d":"M16 15l6 -6","key":"svg-3"}],["path",{"d":"M10 12h4","key":"svg-4"}]]

const IconMathXMinusX = createReactComponent('outline', 'math-x-minus-x', 'MathXMinusX', __iconNode);

export default IconMathXMinusX;